@if(step === 0) {
<form [formGroup]="formControl" class="modal-help" [ngClass]="{'p-30':  currentScreen === 'Tablet', 'p-20': currentScreen === 'Handset'}">
  <div class="d-flex flex-column h-100 p-r-20" style="overflow-y: auto; overflow-x: hidden;" #dialogContainer>
    <div class="d-flex flex-row justify-between align-item-center b-bottom">
      <div class="d-flex flex-column justify-center">
        <p class="mat-headline-5 color-text m-b-5" id="help-modal.help.title">{{ 'help-modal.help.title' | translate }}
        </p>
      </div>
      <div (click)="closeDialog()" style="width: 40px;height: 40px;" id="close-dialog"
        class="d-flex flex-row justify-center align-item-center cursor-pointer" hideLTLarge>
        <fa-icon [icon]="['fal','times']" [fixedWidth]="false" class="font-16 icon-border"></fa-icon>
      </div>
    </div>
    <div class="w-100 m-t-20 p-t-5 m-b-30">
      <p class="mat-body-1 color-text m-0" id="help-modal.help.subtitle">{{ 'help-modal.help.subtitle' | translate }}
      </p>
    </div>

    <div class="w-100 m-b-10">
      <p class="mat-subtitle-1 color-text m-b-10" id="help-modal.help.lbl-title">{{'help-modal.help.lbl-title' |
        translate}}&nbsp;*</p>
      <mat-form-field class="w-100 input-regular density-button m-b-8" appearance="outline">
        <input type="text" matInput placeholder="{{'remuneration-page.filter.write-text' | translate}}" maxlength="300"
          id="input-title" formControlName="title">
        @if (formControl.controls['title'].hasError('required')) {
        <mat-error id="text-error-required-input-title">
          <span class="font-12">
            {{ 'help-modal.help.lbl-title' | translate }} {{ 'login-page.login-form.is-required' | translate }}
          </span>
        </mat-error>
        }
      </mat-form-field>

    </div>

    <div class="w-100 m-b-10">
      <p class="mat-subtitle-1 color-text m-b-10" id="help-modal.help.lbl-description">
        {{'help-modal.help.lbl-description' | translate}}&nbsp;*</p>
      <mat-form-field class="w-100 input-regular density-button m-b-8 p-t-4 text-area" appearance="outline">
        <textarea type="text" matInput placeholder="{{'remuneration-page.filter.write-text' | translate}}"
          maxlength="5000" formControlName="description" id="input-description" rows="3"></textarea>
        @if (formControl.controls['description'].hasError('required')) {
        <mat-error id="text-error-required-input-description"><span class="font-12">{{'help-modal.help.lbl-description'
            | translate}} {{ 'login-page.login-form.is-required' | translate }}</span></mat-error>
        }
      </mat-form-field>
    </div>

    <div>
      <p class="mat-subtitle-1 m-b-10 color-text" id="help-modal.help.lbl-attachments">
        {{'help-modal.help.lbl-attachments' | translate }}</p>
    </div>

    <input type="file" (cancel)="this.loadingFile = false" (change)="onFileSelected($event)" class="d-none" #inputFile
      id="file-input">

    @if( files.length > 0){
    <div class="border-file d-flex flex-column">
      <div class="d-flex flex-column">
        @for (file of files; track file; let idx = $index) {
        <div class="d-flex justify-between item-file cursor-pointer" (click)="replace(idx)">
          <div class="d-flex align-item-center">
            @if( isValidImageType(file.base64 )){
            <img [src]="file.base64" width="35px" height="35px" class="m-r-8">
            }@else {
            <fa-icon [icon]="['fal','file']" [fixedWidth]="false" class="m-r-8 font-35"></fa-icon>
            }

            <div>
              <p class="m-0 font-14 text-title-file">{{ file.name }}</p>
              @if( !file.valid ){
              <p class="m-0 text-warning p-t-4" id="help-modal.help.max-size">{{'help-modal.help.max-size' | translate
                }} 10 MB</p>
              }
            </div>
          </div>

          <div class="d-flex align-item-center cursor-pointer" id="added-file-{{idx}}" (click)="deleteFile(idx)">
            <button class="default-mini mat-elevation-z0 button-trash">
              <fa-icon [icon]="['fal','trash-can']" class="font-16 icon" [fixedWidth]="false"
                matTooltip="{{'help-modal.help.delete' | translate }}" #tooltip="matTooltip"
                [id]="'delete-file-' + idx">
              </fa-icon>
            </button>

          </div>
        </div>
        }
      </div>

    </div>
    }
    <div class="d-flex m-b-15">

      <button (click)="openInputFile( inputFile )" mat-stroked-button disableRipple id="btn-load-img" type="button"
        [disabled]="loadingFile" class="w-100 secondary" [class.m-t-12]="files.length > 0">
        @if( loadingFile ){
        <mat-icon>
          <mat-spinner diameter="18">
          </mat-spinner>
        </mat-icon>
        }@else {
        <fa-icon [icon]="['fal','plus']" class="font-14 m-r-10"></fa-icon>
        <span style="text-transform: none;" class="font-13" id="help-modal.help.add-file">{{'help-modal.help.add-file' |
          translate}}</span>
        }

      </button>
    </div>
  </div>



  <!-- DESKTOP -->
  <div class="m-t-45 d-flex justify-end p-r-20" hideLTLarge>

    <button mat-stroked-button disableRipple class="secondary" id="btn-cancel" type="button" (click)="closeDialog()">
      {{'help-modal.help.cancel' | translate }}
    </button>

    <button (click)="sendRequest()" mat-raised-button disableRipple id="btn-acept" color="primary" type="button"
      [disabled]="loadingService" class="m-l-15" [disabled]="!formControl.valid || isFileValid() || loadingFile">
      @if( !loadingService ){
      {{'help-modal.help.send' | translate}}
      }@else {
      <p class="m-0 m-t-10 p-r-20 p-l-20">
        <mat-icon>
          <mat-spinner diameter="20"></mat-spinner>
        </mat-icon>
      </p>

      }
    </button>
  </div>

  <!-- TABLET/MOBILE -->
  <div class=" d-flex justify-end flex-column m-b-15" hideLarge>

    <button (click)="sendRequest()" mat-raised-button disableRipple id="btn-acept" color="primary" type="button"
      [disabled]="loadingService" class="full-width" [disabled]="!formControl.valid || isFileValid() || loadingFile">
      @if( !loadingService ){
      {{'help-modal.help.send' | translate}}
      }@else {
      <p class="m-0 m-t-10 p-r-20 p-l-20">
        <mat-icon>
          <mat-spinner diameter="20"></mat-spinner>
        </mat-icon>
      </p>

      }
    </button>

    <button mat-stroked-button disableRipple id="btn-cancel" type="button" (click)="closeDialog()"
      class="full-width m-t-20 secondary">
      {{'help-modal.help.cancel' | translate }}
    </button>

  </div>

</form>
}@else{
<div class="modal-help" [ngClass]="{'p-30':  currentScreen === 'Tablet', 'p-20': currentScreen === 'Handset'}">
  <div class="d-flex flex-column h-100" style="overflow-y: auto; overflow-x: hidden;">
    <div class="d-flex flex-row justify-between align-item-center b-bottom">
      <div class="d-flex flex-column justify-center">
        @if(success){
        <p class="modal-help-subtitle color-text m-b-5" id="user-need-help" id="help-modal.help.mobile-success-title">{{
          'help-modal.help.mobile-success-title' | translate }}</p>
        }@else{
        <p class="modal-help-subtitle color-text m-b-5" id="user-need-help" id="help-modal.help.mobile-error-title">{{
          'help-modal.help.mobile-error-title' | translate }}</p>
        }
      </div>
    </div>
    <div class="w-100 m-t-20 m-b-30">
      @if(success){
      <p class="nova-14-400 color-text m-0" id="help-modal.help.mobile-message-success">{{
        'help-modal.help.mobile-message-success' | translate }}</p>
      }@else{
      <p class="nova-14-400 color-text m-0" id="help-modal.help.error-mobile-description">{{
        'help-modal.help.error-mobile-description' | translate }}</p>

      }
    </div>
  </div>
  <div class="d-flex justify-end d-flex flex-column m-b-15" hideLarge>
    @if( !success ){
    <button (click)="retry()" mat-raised-button disableRipple id="btn-retry" color="primary" type="button"
      class="full-width">
      {{'help-modal.help.retry' | translate}}
    </button>

    <button mat-stroked-button disableRipple id="btn-cancel" type="button" (click)="closeDialog()"
      class="full-width m-t-20 secondary">
      {{'help-modal.help.close' | translate }}
    </button>
    }@else{
    <button (click)="closeDialog()" id="btn-close" mat-raised-button disableRipple color="primary" type="button"
      class="full-width">
      {{'help-modal.help.close' | translate}}
    </button>
    }

  </div>
</div>
}
